import { createUseZero } from "@rocicorp/zero/react";

import { type Schema } from "@/zero/schema";

export const useZero = createUseZero<Schema>();
